import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { customInstance } from '@/api/mutator';

interface GenerateProfileResponse {
  assistantPreferences?: {
    draftingPreferences: string;
    generalInfo: string;
  } | null;
  id: string;
}

interface UseGenerateProfileOptions {
  onError?: (error: Error) => void;
  onSuccess?: (data: GenerateProfileResponse) => void;
}

export const useGenerateProfile = ({ onError, onSuccess }: UseGenerateProfileOptions = {}) => {
  return useMutation({
    mutationFn: async () => {
      return customInstance<GenerateProfileResponse>({
        data: {},
        method: 'POST',
        url: ENDPOINTS.USER.GENERATE_PROFILE,
      });
    },
    onError: (error: unknown) => {
      console.error('Failed to generate profile:', error);
      onError?.(error instanceof Error ? error : new Error(String(error)));
    },
    // The mutator throws on any non-2xx response, so onSuccess only runs on a
    // successful generation — no envelope status flag to branch on anymore.
    onSuccess: (response) => {
      onSuccess?.(response);
    },
    retry: false,
  });
};
